/**
 * 用於ant inputs組件的各種props
 */
export default {
  methods: {
    /**
     * [a-input-number][formatter]
     */
    commaFormater(value) {
      return value
      // const val = value.toString()
      // const regexp = /\B(?=(\d{3})+(?!\d))/g
      // if (val.indexOf('.') >= 0) {
      //   const int = val.split('.')[0]
      //   const decimal = val.split('.')[1]
      //   return `${int.replace(regexp, ',')}.${decimal}`
      // }
      // return val.replace(regexp, ',')
    },
    /**
     * [a-input-number][parser]
     */
    numberParser(value) {
      return value.toString().replace(/[^0-9.-]/g, '')
    }
  }
}
